import React from 'react';
import Button from './Button';
import * as Icons from '../../assets/svg/icons';

const SettingsPanel = ({ 
  isOpen, 
  onClose, 
  microphones, 
  cameras,
  selectedMicId,
  selectedCameraId,
  onMicChange,
  onCameraChange
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[110] flex items-center justify-center p-4">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 transition-opacity duration-300"
        style={{ backgroundColor: 'rgba(0, 0, 0, 0.4)', backdropFilter: 'blur(4px)' }}
        onClick={onClose}
      />
      
      {/* Panel - Compact and Professional */}
      <div 
        className="relative w-full max-w-sm overflow-hidden"
        style={{ 
          backgroundColor: '#1a1a1f', 
          borderRadius: '16px', 
          border: '1px solid rgba(255, 255, 255, 0.1)',
          boxShadow: '0 20px 40px rgba(0, 0, 0, 0.4)'
        }}
      >
        <div 
          className="px-4 py-3 flex items-center justify-between"
          style={{ borderBottom: '1px solid rgba(255, 255, 255, 0.08)' }}
        >
          <h2 className="text-base font-semibold text-white">Settings</h2>
          <button 
            onClick={onClose}
            className="p-1.5 rounded-lg transition-colors"
            style={{ color: '#a1a1aa' }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
              e.currentTarget.style.color = '#ffffff';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
              e.currentTarget.style.color = '#a1a1aa';
            }}
          >
            <Icons.XIcon className="w-4 h-4" />
          </button>
        </div>

        <div className="p-4 space-y-4">
          <section className="space-y-2">
            <div className="flex items-center gap-2">
              <Icons.MicIcon className="w-4 h-4" color="#60a5fa" />
              <label className="text-xs font-medium" style={{ color: '#9ca3af' }}>Microphone</label>
            </div>
            <div className="relative">
              <select 
                value={selectedMicId}
                onChange={(e) => onMicChange(e.target.value)}
                className="w-full py-2.5 px-3 text-white text-sm outline-none transition-all appearance-none cursor-pointer pr-8"
                style={{ 
                  backgroundColor: 'rgba(255, 255, 255, 0.05)', 
                  border: '1px solid rgba(255, 255, 255, 0.1)',
                  borderRadius: '8px'
                }}
                onFocus={(e) => e.currentTarget.style.boxShadow = '0 0 0 2px rgba(59, 130, 246, 0.3)'}
                onBlur={(e) => e.currentTarget.style.boxShadow = 'none'}
              >
                {microphones.length > 0 ? (
                  microphones.map((mic, index) => {
                    // enumerateDevices() returns MediaDeviceInfo (deviceId), not id.
                    // Using mic.id meant the select value never matched
                    // selectedMicId and changing device published nothing.
                    const id = mic.deviceId ?? mic.id ?? '';
                    return (
                      <option key={id || `mic-${index}`} value={id} style={{ backgroundColor: '#1a1a1f' }}>
                        {mic.label || `Mic ${String(id).slice(0, 4) || index + 1}`}
                      </option>
                    );
                  })
                ) : (
                  <option style={{ backgroundColor: '#1a1a1f' }}>No inputs detected</option>
                )}
              </select>
              <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none" style={{ color: '#6b7280' }}>
                <Icons.ChevronDownIcon className="w-4 h-4" />
              </div>
            </div>
          </section>

          <section className="space-y-2">
            <div className="flex items-center gap-2">
              <Icons.CameraIcon className="w-4 h-4" style={{ color: '#60a5fa' }} />
              <label className="text-xs font-medium" style={{ color: '#9ca3af' }}>Camera</label>
            </div>
            <div className="relative">
              <select 
                value={selectedCameraId}
                onChange={(e) => onCameraChange(e.target.value)}
                className="w-full py-2.5 px-3 text-white text-sm outline-none transition-all appearance-none cursor-pointer pr-8"
                style={{ 
                  backgroundColor: 'rgba(255, 255, 255, 0.05)', 
                  border: '1px solid rgba(255, 255, 255, 0.1)',
                  borderRadius: '8px'
                }}
                onFocus={(e) => e.currentTarget.style.boxShadow = '0 0 0 2px rgba(59, 130, 246, 0.3)'}
                onBlur={(e) => e.currentTarget.style.boxShadow = 'none'}
              >
                {cameras.length > 0 ? (
                  cameras.map((cam, index) => {
                    const id = cam.deviceId ?? cam.id ?? '';
                    return (
                      <option key={id || `cam-${index}`} value={id} style={{ backgroundColor: '#1a1a1f' }}>
                        {cam.label || `Cam ${String(id).slice(0, 4) || index + 1}`}
                      </option>
                    );
                  })
                ) : (
                  <option style={{ backgroundColor: '#1a1a1f' }}>No cameras detected</option>
                )}
              </select>
              <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none" style={{ color: '#6b7280' }}>
                <Icons.ChevronDownIcon className="w-4 h-4" />
              </div>
            </div>
          </section>
        </div>

        <div 
          className="px-4 py-3 flex justify-end"
          style={{ 
            borderTop: '1px solid rgba(255, 255, 255, 0.08)'
          }}
        >
          <Button 
            onClick={onClose} 
            variant="primary" 
            size="sm" 
            className="px-6 py-2 text-sm font-medium"
          >
            Done
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SettingsPanel;